<template>
  <div class="recherche-list">
    <h2>Address Pool</h2>
    <b-alert v-model="hasError" variant="danger">
      {{ errorMessage }}
    </b-alert>
    <div v-if="showRendered">
      <div class="pool-container">
        <dx-data-grid
          :data-source="poolData"
          :ref="dataGridRecherchePool"
          id="gridContainerRecherchePool"
          class="meilisearch-datagrid-pool"
          :show-borders="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :column-min-width="50"
          columnResizingMode="widget"
          :showColumnLines="true"
          :showRowLines="true"
          :no-data-text="$t('general.noEntries')"
          :column-auto-width="false"
          :word-wrap-enabled="true"
          :hover-state-enabled="true"
          @toolbar-preparing="onToolbarPreparing"
          @contentReady="contentReady"
          @row-removed="removeItem"
          @row-prepared="changeRowColor"
          :sync-lookup-filter-values="false"
        >
          <dx-editing
            :allow-deleting="true"
            mode="row"
            :confirmDelete="false"
            :use-icons="true"
          />
          <dx-scrolling
            mode="virtual"
            row-rendering-mode="virtual"
          />
          <dx-filter-panel :visible="true"/>
          <dx-filter-row
            :visible="true"
            apply-filter=""
          />
          <dx-header-filter
            :visible="true"
          />
          <dx-column-chooser
            :enabled="false"
            mode="select"
          >
            <dx-column-chooser-search
              :enabled="true"
            />
          </dx-column-chooser>
          <dx-column
            :caption="$t('recherche.search.id')"
            data-field="id"
            data-type="number"
            :allow-hiding="false"
            :width="100"
            cell-template="link-to-crm-template"
            :editor-options="{ showClearButton: true }"
          />
          <dx-column
            caption="Datum"
            data-field="datum"
            :width="200"
            data-type="date"
            format="dd.MM.yyyy"
          />
          <dx-column
            :caption="$t('recherche.detail.company')"
            data-field="_formatted.company"
            :calculate-cell-value="tempDevCompany"
            :width="150"
            :editor-options="{ showClearButton: true }"
            :encodeHtml="false"
          />
          <dx-column
            :caption="$t('recherche.detail.firstname')"
            data-field="_formatted.firstName"
            :editor-options="{ showClearButton: true }"
            :width="200"
            :encodeHtml="false"
          />
          <dx-column
            :caption="$t('recherche.detail.lastname')"
            data-field="_formatted.lastName"
            :editor-options="{ showClearButton: true }"
            :width="200"
            :encodeHtml="false"
          />
          <dx-column
            data-field="_formatted.crmProfiles[0].oneLiner_en)"
            :caption="$t('recherche.detail.oneLinerEn')"
            :calculate-cell-value="calculateOneLiner"
            :width="250"
            :encodeHtml="false"
          />
          <dx-column
            :caption="$t('recherche.detail.descriptionEN')"
            data-field="_formatted.crmProfiles[0].description_open_en"
            :calculate-cell-value="calculateDescription"
            :width="400"
            :visible="false"
            :encodeHtml="false"
          />
          <dx-column
            data-field="_formatted.streetB"
            :caption="$t('recherche.detail.streetB')"
            :editor-options="{ showClearButton: true }"
            :width="200"
            :visible="false"
            :encodeHtml="false"
          />
          <dx-column
            data-field="_formatted.zipB"
            :caption="$t('recherche.detail.zipB')"
            :visible="false"
            :width="200"
            :editor-options="{ showClearButton: true }"
            :encodeHtml="false"
          />
          <dx-column
            data-field="_formatted.cityB"
            :caption="$t('recherche.detail.cityB')"
            :width="200"
            :editor-options="{ showClearButton: true }"
            :encodeHtml="false"
          />
          <dx-column
            :caption="$t('recherche.detail.countryB')"
            data-field="countryBId"
            cell-template="countryBTemplate"
            :editor-options="{ showClearButton: true }"
            :width="200"
          >
            <dx-lookup
              :data-source="countryTypes"
              display-expr="land"
              value-expr="field_001"
            />
          </dx-column>
          <dx-column
            data-field="incorporationDate"
            :caption="$t('recherche.detail.incorporationDate')"
            :width="200"
            data-type="date"
            format="dd.MM.yyyy"
          />
          <dx-column
            data-field="universityId"
            :caption="$t('recherche.detail.university')"
            cell-template="universityTemplate"
            :editor-options="{ showClearButton: true }"
            :width="200"
          >
            <dx-lookup
              :data-source="universityTypes"
              display-expr="university"
              value-expr="field_001"
            />
          </dx-column>
          <dx-column
            data-field="universityFacultyIDId"
            :caption="$t('recherche.detail.faculty')"
            cell-template="facultyTemplate"
            :editor-options="{ showClearButton: true }"
            :width="200"
          >
            <dx-lookup
              :data-source='facultyUniversityTypes'
              display-expr='departementFaculty'
              value-expr='field_001'
            />
          </dx-column>
          <dx-column
            data-field="_formatted.mobileB"
            :caption="$t('recherche.detail.mobile')"
            :visible="false"
            :width="150"
            :encodeHtml="false"
          />
          <dx-column
            data-field="_formatted.phoneB"
            :caption="$t('recherche.detail.phoneB')"
            :visible="false"
            :width="150"
            :encodeHtml="false"
          />
          <dx-column
            data-field="_formatted.emailB1"
            :caption="$t('recherche.detail.email')"
            :width="200"
            :encodeHtml="false"
          />
          <dx-column
            data-field="_formatted.emailB2"
            :caption="$t('recherche.detail.emailB2')"
            :width="200"
            :visible="false"
            :encodeHtml="false"
          />
          <dx-column
            data-field="_formatted.facebookB"
            :caption="$t('recherche.detail.facebookB')"
            :width="200"
            :visible="false"
            :encodeHtml="false"
          />
          <dx-column
            data-field="_formatted.linkedInB"
            :caption="$t('recherche.detail.linkedInB')"
            :width="200"
            :visible="false"
            :encodeHtml="false"
          />
          <dx-column
            data-field="_formatted.twitterB"
            :caption="$t('recherche.detail.twitterB')"
            :width="200"
            :visible="false"
            :encodeHtml="false"
          />
          <dx-column
            data-field="_formatted.instagramB"
            :caption="$t('recherche.detail.instagramB')"
            :width="200"
            :visible="false"
            :encodeHtml="false"
          />
          <dx-column
            data-field="_formatted.similarwebB"
            :caption="$t('recherche.detail.similarwebB')"
            :width="200"
            :visible="false"
            :encodeHtml="false"
          />
          <dx-column
            data-field="_formatted.alexaB"
            :caption="$t('recherche.detail.alexaB')"
            :width="200"
            :visible="false"
            :encodeHtml="false"
          />
          <dx-column
            data-field="salutationId"
            :caption="$t('recherche.detail.salutationId')"
            :editor-options="{ showClearButton: true }"
            :width="150"
          >
            <dx-lookup
              :data-source='salutationTypes'
              :display-expr='getDisplayExpr'
              value-expr='ansprechzeile_id'
            />
          </dx-column>
          <dx-column
            data-field="_formatted.internetB"
            :caption="$t('recherche.detail.internet')"
            :width="200"
            :encodeHtml="false"
          />
          <dx-column
            data-field="startupPhaseId"
            :caption="$t('recherche.detail.startupPhase')"
            cell-template="startupPhaseTemplate"
            :width="150"
            :editor-options="{ showClearButton: true }"
          >
            <dx-lookup
              :data-source="startupPhaseTypes"
              display-expr="startupphase"
              value-expr="field_001"
            />
          </dx-column>
          <dx-column
            v-if="checkAdmin(currentUser.mitarbeiterId)"
            data-field="totalFundings"
            :caption="$t('recherche.detail.totalFunding')"
            :format="totalFormat"
            :allow-filtering="false"
            :allow-sorting="true"
            :width="150"
          />
          <dx-column
            data-field="technologyId"
            :caption="$t('recherche.detail.technology')"
            cell-template="technologyTemplate"
            :width="200"
            :editor-options="{ showClearButton: true }"
          >
            <dx-lookup
              :data-source="brancheTypes"
              display-expr="brancheEn"
              value-expr="field_001"
              :allow-clearing="true"
            />
          </dx-column>
          <dx-column
            :caption="$t('recherche.detail.sectors')"
            data-field="sectors"
            :calculate-cell-value="calculateSectors"
            :width="400"
            :visible="false"
          />
          <dx-column
            :caption="$t('recherche.detail.awards')"
            data-field="contests"
            :calculate-cell-value="calculateAwards"
            :width="400"
            :visible="false"
          />
          <dx-column
            :caption="$t('recherche.detail.events')"
            data-field="eventlistTitleEN"
            cell-template="eventsTemplate"
            :width="400"
            :visible="false"
          />
          <dx-column
            :caption="$t('recherche.detail.roles')"
            data-field="roles"
            :calculate-cell-value="calculateRoles"
            :width="400"
            :visible="false"
          />
          <dx-column
            data-field="unispinoffId"
            :caption="$t('recherche.detail.unispinoff')"
            cell-template="uniSpinOffTemplate"
            :visible="false"
            :width="200"
            :editor-options="{ showClearButton: true }"
          >
            <dx-lookup
              :data-source="universityTypes"
              display-expr="university"
              value-expr="field_001"
            />
          </dx-column>
          <dx-column
            data-field="priovlabId"
            :caption="$t('recherche.detail.priovlabId')"
            cell-template="prioVlabTemplate"
            :visible="false"
            :width="150"
            :editor-options="{ showClearButton: true }"
          >
            <dx-lookup
              :data-source="priovlabTypes"
              display-expr="status"
              value-expr="field_001"
            />
          </dx-column>
          <dx-column
            data-field="prioXMasId"
            :caption="$t('recherche.detail.prioXMasId')"
            cell-template="prioXmasTemplate"
            :visible="false"
            :width="150"
            :editor-options="{ showClearButton: true }"

          >
            <dx-lookup
              :data-source="priovlabxmasTypes"
              display-expr="statusxmas"
              value-expr="field_001"
            />
          </dx-column>
          <dx-column
            data-field="vkCaseStatus"
            :caption="$t('recherche.detail.vKCaseStatus')"
            cell-template="vkCaseStatusTemplate"
            :visible="false"
            :width="150"
            :editor-options="{ showClearButton: true }"
          >
            <dx-lookup
              :data-source="vkCaseStatusTypes"
              display-expr="casestatus"
              value-expr="field_001"
            />
          </dx-column>
          <dx-column
            data-field="vKacademiclinkId"
            :caption="$t('recherche.detail.vKacademiclink')"
            cell-template="vkAcademicLinkTemplate"
            :visible="false"
            :width="200"
            :editor-options="{ showClearButton: true }"
          >
            <dx-lookup
              :data-source="universityTypes"
              display-expr="university"
              value-expr="field_001"
            />
          </dx-column>
          <dx-column
            data-field="_formatted.tradeRegisterNr"
            :caption="$t('recherche.detail.tradeRegisterNr')"
            :width="150"
            :visible="false"
            :editor-options="{ showClearButton: true }"
            :encodeHtml="false"
          />
          <dx-column
            data-field="legalFormId"
            :caption="$t('recherche.detail.legalFormId')"
            cell-template="legalFormTemplate"
            :visible="false"
            :width="150"
            :editor-options="{ showClearButton: true }"
          >
            <dx-lookup
              :data-source='rechtsformTypes'
              display-expr='rechtsform'
              value-expr='field_001'
            />
          </dx-column>
          <dx-column
            data-field="_formatted.streetP"
            :caption="$t('recherche.detail.streetP')"
            :width="200"
            :visible="false"
            :editor-options="{ showClearButton: true }"
            :encodeHtml="false"
          />
          <dx-column
            data-field="_formatted.zipP"
            :caption="$t('recherche.detail.zipP')"
            :width="200"
            :visible="false"
            :editor-options="{ showClearButton: true }"
            :encodeHtml="false"
          />
          <dx-column
            data-field="_formatted.cityP"
            :caption="$t('recherche.detail.cityP')"
            :width="200"
            :visible="false"
            :editor-options="{ showClearButton: true }"
            :encodeHtml="false"
          />
          <dx-column
            :caption="$t('recherche.detail.countryP')"
            data-field="countryPId"
            cell-template="countryPTemplate"
            :editor-options="{ showClearButton: true }"
            :width="200"
            :visible="false"
          >
            <dx-lookup
              :data-source="countryTypes"
              display-expr="land"
              value-expr="field_001"
            />
          </dx-column>
          <dx-column
            data-field="_formatted.mobileP"
            :caption="$t('recherche.detail.mobileP')"
            :visible="false"
            :width="150"
            :encodeHtml="false"
          />
          <dx-column
            data-field="_formatted.phoneP"
            :caption="$t('recherche.detail.phoneP')"
            :visible="false"
            :width="150"
            :encodeHtml="false"
          />
          <dx-column
            data-field="_formatted.emailP1"
            :caption="$t('recherche.detail.emailP1')"
            :width="200"
            :visible="false"
            :encodeHtml="false"
          />
          <dx-column
            data-field="_formatted.emailP2"
            :caption="$t('recherche.detail.emailP2')"
            :width="200"
            :visible="false"
            :encodeHtml="false"
          />
          <dx-column
            data-field="_formatted.facebookP"
            :caption="$t('recherche.detail.facebookP')"
            :width="200"
            :visible="false"
            :encodeHtml="false"
          />
          <dx-column
            data-field="_formatted.linkedInP"
            :caption="$t('recherche.detail.linkedInP')"
            :width="200"
            :visible="false"
            :encodeHtml="false"
          />
          <dx-column
            data-field="_formatted.twitterP"
            :caption="$t('recherche.detail.twitterP')"
            :width="200"
            :visible="false"
            :encodeHtml="false"
          />
          <dx-column
            data-field="birthday"
            :caption="$t('recherche.detail.birthday')"
            :width="200"
            data-type="date"
            format="dd.MM.yyyy"
            :visible="false"
            alignment="right"
          />
          <dx-column
            data-field="languageId"
            :caption="$t('recherche.detail.languageId')"
            cell-template="languageTemplate"
            :visible="false"
            :width="150"
            :editor-options="{ showClearButton: true }"
          >
            <dx-lookup
              :data-source="languagesTypes"
              display-expr="spracheEN"
              value-expr="field_001"
            />
          </dx-column>
          <dx-column
            data-field="educationId"
            :caption="$t('recherche.detail.educationId')"
            cell-template="educationTemplate"
            :visible="false"
            :width="150"
            :editor-options="{ showClearButton: true }"
          >
            <dx-lookup
              :data-source="educationTypes"
              display-expr="education"
              value-expr="field_001"
            />
          </dx-column>
          <dx-column
            data-field="_formatted.position"
            :caption="$t('recherche.detail.position')"
            :visible="false"
            :width="180"
            :editor-options="{ showClearButton: true }"
            :encodeHtml="false"
          />
          <dx-column
            data-field="kantonId"
            :caption="$t('recherche.detail.kantonId')"
            cell-template="cantonTemplate"
            :visible="false"
            :width="150"
            :editor-options="{ showClearButton: true }"
          >
            <dx-lookup
              :data-source="cantonTypes"
              display-expr="kantonEN"
              value-expr="field_001"
            />
          </dx-column>
          <dx-column
            v-if="checkAdmin(currentUser.mitarbeiterId)"
            data-field="crmProfiles.peopleFemaleFounders"
            :caption="$t('recherche.detail.peoplefemalefounders')"
            :calculate-cell-value="calculateFemaleFounders"
            :visible="false"
            :width="150"
          />
          <dx-column
            v-if="checkAdmin(currentUser.mitarbeiterId)"
            data-field="crmProfiles.peopleMaleFounders"
            :caption="$t('recherche.detail.peoplemalefounders')"
            :calculate-cell-value="calculateMaleFounders"
            :visible="false"
            :width="150"
          />
          <dx-column
            v-if="checkAdmin(currentUser.mitarbeiterId)"
            data-field="crmProfiles[0].totalEmployee"
            :caption="$t('recherche.detail.totalEmployee')"
            :calculate-cell-value="calculateEmployees"
            :visible="false"
            :width="100"
          />
          <dx-column
            :caption="$t('recherche.search.vleadersproblemopportunity')"
            data-field="_formatted.crmProfiles[0].vleadersproblemopportunity"
            :calculate-cell-value="calculateOpportunity"
            :width="400"
            :visible="false"
            :encodeHtml="false"
          />
          <dx-column
            :caption="$t('recherche.search.vleadersProductservice')"
            data-field="_formatted.crmProfiles[0].vleadersProductservice"
            :calculate-cell-value="calculateProductservice"
            :width="400"
            :visible="false"
            :encodeHtml="false"
          />
          <dx-column
            caption="Vleaders Technology"
            data-field="_formatted.crmProfiles[0].vleadersTechnologie"
            :calculate-cell-value="calculateTechnology"
            :width="400"
            :visible="false"
            :encodeHtml="false"
          />
          <dx-column
            caption="Vleaders Target Customers"
            data-field="_formatted.crmProfiles[0].vleadersTargetcustomers"
            :calculate-cell-value="calculateTargetcustomers"
            :width="400"
            :visible="false"
            :encodeHtml="false"
          />
          <dx-column
            caption="Vleaders Market Competition"
            data-field="_formatted.crmProfiles[0].vleadersMarketcompetition"
            :calculate-cell-value="calculateMarketCompetition"
            :width="400"
            :visible="false"
            :encodeHtml="false"
          />
          <dx-column
            caption="Vleaders Team"
            data-field="_formatted.crmProfiles[0].vleadersTeam"
            :calculate-cell-value="calculateVleadersTeam"
            :width="400"
            :visible="false"
            :encodeHtml="false"
          />
          <dx-column
            caption="Vleaders Achievements"
            data-field="_formatted.crmProfiles[0].vLeadersAchievements"
            :calculate-cell-value="calculateAchievements"
            :width="400"
            :visible="false"
            :encodeHtml="false"
          />
          <dx-column
            caption="Vleaders Financials"
            data-field="_formatted.crmProfiles[0].vleadersFinancials"
            :calculate-cell-value="calculateFinancials"
            :width="400"
            :visible="false"
            :encodeHtml="false"
          />
          <dx-column
            type="buttons"
            :width="50"
            :fixed="true"
            :allow-hiding="false"
          >
            <dx-button name="delete"/>
          </dx-column>
          <template #link-to-crm-template="{ data }">
            <a v-if="data.data.id && data.data.crmProfiles.length" :href="data.data.crmProfiles.find( el => el.profiltypId === 2 ) ? `https://crm.ifj.ch/index.cfm?&page=137659&crm_adresse_id=${data.data.id}`: `https://crm.ifj.ch/index.cfm?&page=137767&crm_adresse_id=${data.data.id}`" target="_blank">{{data.data.id}}</a>
            <a v-else :href="`https://crm.ifj.ch/index.cfm?&page=117525&ADDRESSESID=${data.data.id}`" target="_blank">{{data.data.id}}</a>
          </template>
          <template #cantonTemplate="{ data }">
            <div v-if="data.data.crmCanton.length"><span v-html="data.data._formatted.crmCanton[0].kantonEN"></span></div>
          </template>
          <template #educationTemplate="{ data }">
            <div v-if="data.data.crmEducations.length"><span v-html="data.data._formatted.crmEducations[0].education"></span></div>
          </template>
          <template #languageTemplate="{ data }">
            <div v-if="data.data.crmLanguages.length"><span v-html="data.data._formatted.crmLanguages[0].languageEn"></span></div>
          </template>
          <template #countryPTemplate="{ data }">
            <div v-if="data.data.crmCountriesP.length"><span v-html="data.data._formatted.crmCountriesP[0].land"></span></div>
          </template>
          <template #legalFormTemplate="{ data }">
            <div v-if="data.data.crmRechtsformen.length"><span v-html="data.data._formatted.crmRechtsformen[0].rechtsform"></span></div>
          </template>
          <template #vkAcademicLinkTemplate="{ data }">
            <div v-if="data.data.crmAcademicLink.length"><span v-html="data.data._formatted.crmAcademicLink[0].university"></span></div>
          </template>
          <template #vkCaseStatusTemplate="{ data }">
            <div v-if="data.data.crmCaseStatus.length"><span v-html="data.data._formatted.crmCaseStatus[0].casestatus"></span></div>
          </template>
          <template #prioXmasTemplate="{ data }">
            <div v-if="data.data.crmPrioXMas.length"><span v-html="data.data._formatted.crmPrioXMas[0].statusXmas"></span></div>
          </template>
          <template #prioVlabTemplate="{ data }">
            <div v-if="data.data.crmPrioVlab.length"><span v-html="data.data._formatted.crmPrioVlab[0].status"></span></div>
          </template>
          <template #uniSpinOffTemplate="{ data }">
            <div v-if="data.data.crmUniSpinOff.length"><span v-html="data.data._formatted.crmUniSpinOff[0].university"></span></div>
          </template>
          <template #technologyTemplate="{ data }">
            <div v-if="data.data.crmBranchen.length"><span v-html="data.data._formatted.crmBranchen[0].brancheEn"></span></div>
          </template>
          <template #startupPhaseTemplate="{ data }">
            <div v-if="data.data.crmStartupphases.length"><span v-html="data.data._formatted.crmStartupphases[0].startupphase"></span></div>
          </template>
          <template #facultyTemplate="{ data }">
            <div v-if="data.data.crmUniversityFaculty.length"><span v-html="data.data._formatted.crmUniversityFaculty[0].departementFaculty"></span></div>
          </template>
          <template #universityTemplate="{ data }">
            <div v-if="data.data.crmUniversityFaculty.length"><span v-html="data.data._formatted.crmUniversityFaculty[0].university"></span></div>
          </template>
          <template #countryBTemplate="{ data }">
            <div v-if="data.data.crmCountriesB.length"><span v-html="data.data._formatted.crmCountriesB[0].land"></span></div>
          </template>
          <template #eventsTemplate="{ data }">
            <div v-if="data.data.eventlistTitleEN.length">
              <span
                v-for="(event, index) in data.data.eventlistTitleEN"
                :key="index"
              >
                <span>{{event}}, </span>
              </span>
            </div>
          </template>
          <template #totalGroupCount>
            <div class="informer" v-if="totalCount > 0">
              <span class="count">{{ filteredCount !== 0 ? filteredCount : totalCount }} results out of {{ totalCount }} records</span>
            </div>
          </template>
          <dx-master-detail
            :enabled="true"
            template="masterDetailTemplate"
          />
          <template #masterDetailTemplate="{ data }">
            <detail-template
              :masterDetailData="data"
            />
          </template>
          <template #customizedToolbar>
            <div>
              <v-tooltip top max-width="400" open-delay="500">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    @click="saveList"
                    :disabled="activateSaveList"
                    v-bind="attrs"
                    v-on="on"
                  >Save CRM List</v-btn>
                </template>
                <span>Save the Pool list generated as a CRM saved list</span>
              </v-tooltip>
              <!-- currently not in use -->
              <!--<dx-button
                v-if="lastAddedPoolData.length > 0"
                text="Show last Addresses"
                type="default"
                styling-mode="outlined"
                class="btn-pdl btn-mg"
                @click="showLastAddresses"
              />-->
              <!-- Remove / Add last Adresses need to be fixed (imported list), but its not in use, so uncommented. -->
              <!-- <dx-button
                v-if="lastAddedPoolData.length > 0"
                :text="handleLastAddresses()"
                type="default"
                styling-mode="outlined"
                class="btn-pdl btn-mg"
                @click="removeLastAddresses"
              />-->
              <v-btn
                color="primary"
                class="btn-pdl"
                outlined
                @click="$router.push('address-recherche')"
              >Back to Search</v-btn>
            </div>
          </template>
          <template #actionmenu>
            <div>
              <v-menu
                offset-y
                bottom
                left
                content-class="toolbar-action-menu"
              >
                <template v-slot:activator="{ attrs, on }">
                  <v-btn
                    color="secondary"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <i class="fas fa-cog"></i> Actions
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item
                    link
                    @click="openColumnChooser"
                  >
                    <v-list-item-title><i class="fas fa-columns mr-1"></i> Column Chooser</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    link
                    @click="onExporting"
                  >
                    <v-list-item-title><i class="fas fa-file-excel mr-2"></i> Excel Export</v-list-item-title>
                  </v-list-item>
                  <v-tooltip left max-width="400" open-delay="500">
                    <template v-slot:activator="{ on, attrs }">
                      <v-list-item
                        link
                        @click="openRecherchelistModal"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-list-item-title><i class="fas fa-plus mr-2"></i> Add Recherchelist</v-list-item-title>
                      </v-list-item>
                    </template>
                    <span>Include an existing CRM saved list within the Pool list</span>
                  </v-tooltip>
                  <v-tooltip left max-width="400" open-delay="500">
                    <template v-slot:activator="{ on, attrs }">
                      <v-list-item
                        link
                        @click="clearPool"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-list-item-title><i class="fas fa-trash mr-2"></i> Clear Pool</v-list-item-title>
                      </v-list-item>
                    </template>
                    <span>Remove all the records from the Pool list</span>
                  </v-tooltip>
                </v-list>
              </v-menu>
            </div>
          </template>
        </dx-data-grid>
      </div>
    </div>
    <show-list />
    <save-list :addressList="poolData" :importedSavedLists="importedSavedLists"/>
    <add-recherche-list ref="addRechercheListModal" @mergeRechercheListWithPoolData="mergeRechercheData" @addImportedList="addImportedList"/>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import { exportDataGrid } from 'devextreme/excel_exporter'
  import ExcelJS from 'exceljs'
  import saveAs from 'file-saver'
  import { formattedExportFields } from '@/components/recherche/rechercheSearch/variables.js'
  import DetailTemplate from '@/components/recherche/rechercheSearch/masterDetail/MasterDetail.vue'
  import SaveList from '@/components/recherche/rechercheSearch/recherchePool/SaveList.vue'
  import ShowList from '@/components/recherche/rechercheSearch/recherchePool/LastAddedDataList.vue'
  import AddRechercheList from '@/components/recherche/rechercheSearch/recherchePool/AddRechercheList.vue'
  import { mergeDataFunction } from '@/helpers/externalFunctions.js'
  import _ from 'lodash'
  import DxButton from 'devextreme-vue/button'
  import moment from 'moment'
  import { isAdmin } from '@/helpers/auth.js'
  import {
    DxDataGrid,
    DxScrolling,
    DxColumn,
    DxHeaderFilter,
    DxFilterRow,
    DxFilterPanel,
    DxColumnChooser,
    DxColumnChooserSearch,
    DxLookup,
    DxMasterDetail,
    DxEditing
  } from 'devextreme-vue/data-grid'

  const dataGridRecherchePool = 'dataGrid'

  export default {
    components: {
      DxDataGrid,
      DxScrolling,
      DxColumn,
      DxHeaderFilter,
      DxFilterRow,
      DxFilterPanel,
      DxColumnChooser,
      DxColumnChooserSearch,
      DxLookup,
      DxMasterDetail,
      DetailTemplate,
      DxButton,
      DxEditing,
      SaveList,
      ShowList,
      AddRechercheList
    },
    data () {
      return {
        hasError: false,
        errorMessage: '',
        dataGridRecherchePool,
        defaultState: null,
        totalFormat: { style: 'currency', currency: 'CHF', useGrouping: true, minimumSignificantDigits: 3 },
        totalCount: 0,
        filteredCount: 0,
        updatedTotalCount: false,
        activateSaveList: true,
        currentDate: new Date(),
        showRendered: true
      }
    },
    created () {
      this.getBasicValues('basicValues/GET_FACULTY_UNIVERSITY_TYPES', this.facultyUniversityTypes)
      this.getBasicValues('basicValues/GET_UNIVERSITY_TYPES', this.universityTypes)
      this.getBasicValues('basicValues/GET_BRANCHE_TYPES', this.brancheTypes)
      this.getBasicValues('basicValues/GET_RECHTSFORM_TYPES', this.rechtsformTypes)
      this.getBasicValues('basicValues/GET_COUNTRY_TYPES', this.countryTypes)
      this.getBasicValues('basicValues/GET_SALUTATION_TYPES', this.salutationTypes)
      this.getBasicValues('basicValues/GET_LANGUAGES_TYPES', this.languagesTypes)
      this.getBasicValues('basicValues/GET_EDUCATION_TYPES', this.educationTypes)
      this.getBasicValues('basicValues/GET_CANTON_TYPES', this.cantonTypes)
      this.getBasicValues('basicValues/GET_STARTUPHASE_TYPES', this.startupPhaseTypes)
      this.getBasicValues('basicValues/GET_PRIOVLAB_TYPES', this.priovlabTypes)
      this.getBasicValues('basicValues/GET_PRIOVLABXMAS_TYPES', this.priovlabxmasTypes)
      this.getBasicValues('basicValues/GET_VKCASESTATUS_TYPES', this.vkCaseStatusTypes)
      this.getBasicValues('basicValues/GET_SECTORS', this.sectors)
      this.getBasicValues('basicValues/GET_AWARDS', this.awards)
      this.getBasicValues('basicValues/GET_ROLES', this.roles)

      // merge last added Pool data with current pool
      if (this.lastAddedDataStatus) {
        this.$Progress.start()
        this.mergeData()
      } else {
        this.$Progress.finish()
      }

      if (this.totalCount === 0) {
        this.totalCount = this.poolData.length
      }
    },
    methods: {
      contentReady (e) {
        this.filteredCount = this.dataGrid.totalCount()
        if (this.poolData.length > 0) {
          this.activateSaveList = false
        } else {
          this.activateSaveList = true
        }
      },
      async mergeData () {
        const currentPool = this.poolData
        const addedPoolData = this.lastAddedPoolData
        // const mergedPoolData = _.unionBy(addedPoolData, currentPool, 'id')
        const mergedPoolData = await mergeDataFunction(currentPool, addedPoolData, 'search')
        this.$store.commit('recherche/SET_POOL_LIST', mergedPoolData)
        this.totalCount = mergedPoolData.length
        this.$Progress.finish()
      },
      saveList () {
        this.$store.commit('recherche/SET_SAVE_LIST_STATUS', true)
      },
      openRecherchelistModal () {
        this.$refs.addRechercheListModal.resetForm()
        this.$refs.addRechercheListModal.openModal()
      },
      async mergeRechercheData (msData) {
        const currentPool = this.poolData
        const rechercheData = msData
        // const mergedPoolData = _.unionBy(rechercheData, currentPool, 'id')
        const mergedPoolData = await mergeDataFunction(currentPool, rechercheData, 'savedlist')
        this.$store.commit('recherche/SET_POOL_LIST', mergedPoolData)
        this.totalCount = mergedPoolData.length
      },
      handleLastAddresses () {
        return !this.lastAddedDataStatus ? 'Add last Addresses' : 'Remove last Addresses'
      },
      showLastAddresses () {
        this.$store.commit('recherche/SET_LAST_ADDED_ADDRESSES_STATUS', true)
      },
      removeLastAddresses () {
        if (this.lastAddedDataStatus) {
          const currentPool = this.poolData
          const lastAddedPoolData = this.lastAddedPoolData
          for (const el in lastAddedPoolData) {
            _.remove(currentPool, { id: lastAddedPoolData[el].id })
          }
          this.$store.commit('recherche/SET_POOL_LIST', currentPool)
          this.$store.commit('recherche/SET_LAST_LIST_ADDED_STATUS', false)
          this.totalCount = currentPool.length
          this.dataGrid.refresh()
        } else {
          this.mergeData()
          this.$store.commit('recherche/SET_LAST_LIST_ADDED_STATUS', true)
        }
      },
      removeItem (e) {
        const currentPool = this.poolData
        const lastAddedData = this.lastAddedPoolData
        _.remove(currentPool, { id: e.data.id })
        if (this.lastAddedDataStatus) {
          _.remove(lastAddedData, { id: e.data.id })
        }
        this.$store.commit('recherche/SET_POOL_LIST', currentPool)
        this.$store.commit('recherche/SET_LAST_ADDED_POOLDATA', lastAddedData)
        this.totalCount = this.poolData.length
      },
      changeRowColor (e) {
        if (e.rowType === 'data') {
          if (e.data.sourceSearchList && e.data.sourceSavedList) {
            e.rowElement.style.backgroundColor = '#f0ffeb'
          } else if (e.data.sourceSavedList && !e.data.sourceSearchList) {
            e.rowElement.style.backgroundColor = '#fff5ed'
          } else {
            e.rowElement.style.backgroundColor = '#fff'
          }
        }
      },
      addImportedList (importedList) {
        const currentlyImportedLists = this.importedSavedLists
        currentlyImportedLists.push(importedList)
        this.$store.commit('recherche/SET_IMPORTEDSAVEDLISTES', currentlyImportedLists)
      },
      clearPool () {
        this.$store.commit('recherche/SET_POOL_LIST', [])
        this.$store.commit('recherche/SET_LAST_ADDED_POOLDATA', [])
        this.$store.commit('recherche/SET_LAST_LIST_ADDED_STATUS', false)
        this.$store.commit('recherche/SET_IMPORTEDSAVEDLISTES', [])
        this.totalCount = 0
      },
      onExporting () {
        const workbook = new ExcelJS.Workbook()
        const worksheet = workbook.addWorksheet('Recherche_SearchDx')

        exportDataGrid({
          component: this.dataGrid,
          worksheet: worksheet,
          autoFilterEnabled: true,
          customizeCell: ({ gridCell, excelCell }) => {
            if (gridCell.rowType === 'data') {
              if (formattedExportFields.includes(gridCell.column.dataField)) {
                excelCell.value = (gridCell.value) !== null && (gridCell.value) !== undefined ? (gridCell.value).toString().replaceAll('<em>', '').replaceAll('</em>', '') : null
              }
            }
          }
        }).then(() => {
          workbook.xlsx.writeBuffer().then((buffer) => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${moment(this.currentDate).format('DD.MM.YYYY')}-Recherche-Pool.xlsx`)
          })
        })
        this.dataGrid.cancel = true
      },
      async getBasicValues (storePath, storeValue) {
        if (storeValue.length === 0) {
          try {
            const { errors } = await this.$store.dispatch(storePath)
            if (errors) throw errors
          } catch (err) {
            this.hasError = true
            this.errorMessage = this.$t('formError.unknownwError')
            setTimeout(() => {
              this.hasError = false
            }, 5000)
          }
        }
      },
      tempDevCompany (rowData) {
        return rowData._formatted.company ? rowData._formatted.company.replaceAll('(DEV)', '') : rowData._formatted.company
      },
      calculateSectors (rowData) {
        const listOfSectors = []
        if (rowData.sectors.length) {
          for (const x of rowData.sectors) {
            const obj = this.sectors.find(o => o.field_001 === x)
            if (obj) {
              listOfSectors.push(obj.kategorieDE)
            }
          }
        }
        return listOfSectors.join(', ')
      },
      calculateAwards (rowData) {
        const listOfAwards = []
        if (rowData.contests.length) {
          for (const x of rowData.contests) {
            const obj = this.awards.find(o => o.field_001 === x)
            if (obj) {
              listOfAwards.push(obj.contest_release)
            }
          }
        }
        return listOfAwards.join(', ')
      },
      calculateRoles (rowData) {
        const listOfRoles = []
        if (rowData.roles.length) {
          for (const x of rowData.roles) {
            const obj = this.roles.find(o => o.field_001 === x)
            if (obj) {
              listOfRoles.push(obj.rolle)
            }
          }
        }
        return listOfRoles.join(', ')
      },
      calculateOneLiner (rowData) {
        return this.selectCorrectProfile(rowData._formatted.crmProfiles, 'oneLiner_en')
      },
      calculateDescription (rowData) {
        return this.selectCorrectProfile(rowData._formatted.crmProfiles, 'description_open_en')
      },
      calculateEmployees (rowData) {
        return this.selectCorrectProfile(rowData.crmProfiles, 'totalEmployee')
      },
      calculateFemaleFounders (rowData) {
        return this.selectCorrectProfile(rowData.crmProfiles, 'peopleFemaleFounders')
      },
      calculateMaleFounders (rowData) {
        return this.selectCorrectProfile(rowData.crmProfiles, 'peopleMaleFounders')
      },
      calculateOpportunity (rowData) {
        return this.selectCorrectProfile(rowData._formatted.crmProfiles, 'vleadersproblemopportunity')
      },
      calculateProductservice (rowData) {
        return this.selectCorrectProfile(rowData._formatted.crmProfiles, 'vleadersProductservice')
      },
      calculateTechnology (rowData) {
        return this.selectCorrectProfile(rowData._formatted.crmProfiles, 'vleadersTechnologie')
      },
      calculateTargetcustomers (rowData) {
        return this.selectCorrectProfile(rowData._formatted.crmProfiles, 'vleadersTargetcustomers')
      },
      calculateMarketCompetition (rowData) {
        return this.selectCorrectProfile(rowData._formatted.crmProfiles, 'vleadersMarketcompetition')
      },
      calculateVleadersTeam (rowData) {
        return this.selectCorrectProfile(rowData._formatted.crmProfiles, 'vleadersTeam')
      },
      calculateAchievements (rowData) {
        return this.selectCorrectProfile(rowData._formatted.crmProfiles, 'vLeadersAchievements')
      },
      calculateFinancials (rowData) {
        return this.selectCorrectProfile(rowData._formatted.crmProfiles, 'vleadersFinancials')
      },
      selectCorrectProfile (profiles, column) {
        let columnField = null
        if (profiles.length) {
          const businessProfile = profiles.find(el => el.profiltypId === '2' || el.profiltypId === 2)
          const privateProfile = profiles.find(el => el.profiltypId === '1' || el.profiltypId === 1)

          if (businessProfile) {
            columnField = businessProfile[column]
          } else if (!businessProfile && privateProfile) {
            columnField = privateProfile[column]
          } else {
            columnField = null
          }
        }
        return columnField
      },
      getDisplayExpr (item) {
        return item.geschlecht_PopupExtension ? `${item.ansprechzeile} ${item.geschlecht_PopupExtension}` : `${item.ansprechzeile}`
      },
      onToolbarPreparing (e) {
        e.toolbarOptions.items.unshift({
          location: 'before',
          template: 'totalGroupCount'
        }, {
          location: 'after',
          template: 'customizedToolbar'
        }, {
          location: 'after',
          template: 'actionmenu'
        })
      },
      openColumnChooser () {
        this.dataGrid.showColumnChooser()
      },
      checkAdmin (id) {
        return isAdmin(id)
      }
    },
    computed: {
      ...mapGetters({
        facultyUniversityTypes: 'basicValues/FACULTY_UNIVERSITY_TYPES',
        universityTypes: 'basicValues/UNIVERSITY_TYPES',
        brancheTypes: 'basicValues/BRANCHE_TYPES',
        countryTypes: 'basicValues/COUNTRY_TYPES',
        rechtsformTypes: 'basicValues/RECHTSFORM_TYPES',
        languagesTypes: 'basicValues/LANGUAGES_TYPES',
        educationTypes: 'basicValues/EDUCATION_TYPES',
        cantonTypes: 'basicValues/CANTON_TYPES',
        salutationTypes: 'basicValues/SALUTATION_TYPES',
        priovlabTypes: 'basicValues/PRIOVLAB_TYPES',
        priovlabxmasTypes: 'basicValues/PRIOVLABXMAS_TYPES',
        vkCaseStatusTypes: 'basicValues/VKCASESTATUS_TYPES',
        startupPhaseTypes: 'basicValues/STARTUPHASE_TYPES',
        sectors: 'basicValues/SECTORS',
        awards: 'basicValues/AWARDS',
        roles: 'basicValues/ROLES',
        lastAddedPoolData: 'recherche/LAST_ADDED_POOLDATA',
        poolData: 'recherche/POOL_DATA',
        lastAddedDataStatus: 'recherche/ADDED_LIST_STATUS',
        importedSavedLists: 'recherche/IMPORTEDSAVEDLISTS'
      }),
      ...mapState({
        currentUser: state => state.user.currentUser
      }),
      dataGrid: function () {
        return this.$refs[dataGridRecherchePool].instance
      }
    }
  }
</script>

<style lang="scss">
#gridContainerRecherchePool {
    height: 80vh;
    margin-bottom: 0;
}

.search-container {
  padding-left: 1rem;

  @include media-breakpoint-down(md) {
    padding-left: 0;
  }

}

.meilisearch-datagrid-pool {
  em {
    font-style: normal;
    background: #e4135973;
    padding: 1px;
  }
}

</style>
